"use client";

import { Button } from "./button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./dialog";
import { dispatch, useDialog } from "./use-dialog";

export function DialogContainer() {
  const { dialogs } = useDialog();

  return (
    <>
      {dialogs.map((dialog) => (
        <Dialog
          key={dialog.id}
          open={dialog.open}
          onOpenChange={(open) => {
            if (!open) {
              dispatch({ type: "DISMISS_DIALOG", dialogId: dialog.id });
            }
          }}
        >
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{dialog.title}</DialogTitle>
            </DialogHeader>
            <DialogDescription>{dialog.message}</DialogDescription>
            {(dialog.onAccept || dialog.onReject) && (
              <DialogFooter className="flex justify-between">
                {dialog.onReject && (
                  <Button
                    variant="destructive"
                    onClick={() => {
                      dialog.onReject?.();
                      dispatch({ type: "DISMISS_DIALOG", dialogId: dialog.id });
                    }}
                  >
                    Cancel
                  </Button>
                )}
                {dialog.onAccept && (
                  <Button
                    variant="default"
                    onClick={() => {
                      dialog.onAccept?.();
                      dispatch({ type: "DISMISS_DIALOG", dialogId: dialog.id });
                    }}
                  >
                    OK
                  </Button>
                )}
              </DialogFooter>
            )}
          </DialogContent>
        </Dialog>
      ))}
    </>
  );
}
